<template>
    <section class="q10__page my-14">
        <div class="container px-11 2xl:px-3 m-auto">
            <div class="q10__article_container__title_head">
                <!-- article title head -->
                <article-title-head
                    :options="{
                        category: currentPage.content.oTitleHead_sCategory.text,
                        phrase: currentPage.content.oTitleHead_sPhrase.text,
                        author: currentPage.content.oTitleHead_sAuthor.text,
                        from: currentPage.content.oTitleHead_nFrom.text,
                        to: currentPage.content.oTitleHead_nTo.text,
                        color: 'text-selective_orange',
                    }"
                ></article-title-head>
            </div>

            <div class="q10__article_container__content">
                <div
                    class="
                        q10__article_container__content__vertical_head
                        mx-auto
                        relative
                    "
                >
                    <div class="relative">
                        <article-vertical-head
                            :options="{
                                text: currentPage.content.oVerticalHead_sText
                                    .text,
                                position: 'lg:ml-2 2xl:ml-1',
                                imageAuthor:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image_001.src,
                            }"
                        ></article-vertical-head>

                        <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Interview de J.D. Méchali'
                                ),
                            }"
                            class="top-6 right-1 lg:right-6"
                        />
                    </div>
                </div>

                <div class="q10__article_container__content__paragraphs">
                    <paragraph-first-letter-big
                        :options="{
                            letter: currentPage.content.firstParagraph.text.substr(
                                0,
                                1
                            ),
                            color: 'text-selective_orange',
                        }"
                    />

                    <paragraph :options="{}">
                        <span
                            v-html="
                                currentPage.content.firstParagraph.text.slice(1)
                            "
                        ></span>
                        <!-- <Square
                            :options="{
                                from: 'from-selective_yellow',
                                to: 'to-selective_orange',
                            }"
                        /> -->
                    </paragraph>
                </div>
            </div>
        </div>

        <div class="relative">
            <timeline-carousel
                :options="{
                    timeline: currentPage.timeline,
                }"
            />
            <!-- <hotspot-richmedia
                :options="{
                    icon: 'diaporama',
                    collection: getRichmediaByCollection(
                        currentPage,
                        'Visite d’Henri Proglio'
                    ),
                }"
                class="top-2 left-16"
            /> -->
        </div>
     

        <div class="container px-11 2xl:px-3 m-auto">
            <div class="relative">
                <image-with-descriptions
                    :options="{
                        image:
                            'pages/' +
                            currentPage.slug +
                            '/' +
                            currentPage.images.image_002.src,
                        descriptions: [
                            {
                                text: currentPage.images.image_002.text,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                            {
                                text: currentPage.images.image_002.alt,
                                position: 'top-left', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                        ],
                    }"
                />

                <hotspot-richmedia
                    :options="{
                        icon: 'diaporama',
                        collection: getRichmediaByCollection(
                            currentPage,
                            'Les Bois, un chantier sous la glace'
                        ),
                    }"
                    class="top-2 right-2"
                />
            </div>

            <div class="relative">
                <hotspot-richmedia
                    :options="{
                        icon: 'diaporama',
                        collection: getRichmediaByCollection(
                            currentPage,
                            'Mer de glace, témoignages de MM. de Beauchamps et Gagliardi'
                        ),
                    }"
                    class="-top-2 -right-2"
                />

                <article-note
                    :options="{
                        verticalcontent:
                            currentPage.content.verticalContent.text,
                        title: currentPage.content.sTitle.text,
                        content: currentPage.content.secondParagraph.text,
                        color: {
                            verticalcontent: 'text-cornflower_blue',
                            title: 'text-selective_orange',
                            content: 'text-nandor',
                        },
                        fontSize: {
                            verticalcontent: 'text-4xl md:text-3xl lg:text-4xl',
                            title: 'text-4xl md:text-3xl lg:text-4xl',
                            content: 'text-md md:text-xl lg:text-xl',
                        },
                        margin: {
                            verticalcontent: 'mt-1',
                        },
                    }"
                />
            </div>
        </div>
    </section>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import Paragraph from "../../components/Paragraph.vue";

export default {
    components: { Paragraph },
    name: "Page007",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
.article_note {
    @apply overflow-visible;
}
.q10__article_container {
    &__title_head {
    }

    &__content {
        @apply flex flex-col lg:flex-row justify-center;

        &__vertical_head {
            @apply col-auto;
        }

        &__paragraphs {
            @apply col-auto mt-3;
        }
    }
}
</style>
